import { render, staticRenderFns } from "./EditorBlogPosts.vue?vue&type=template&id=b74c596c&"
import script from "./EditorBlogPosts.vue?vue&type=script&lang=js&"
export * from "./EditorBlogPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports